import React from "react";
import Button from "../Button";
import { FeatureFlags } from "@/cms/models";

const FormLayout: React.FC<{
  children: React.ReactNode;
  formAction: any;
  isPending: boolean;
  submitLabel: string;
  backLabel?: string;
  onBack?: () => void;
  featureFlags?: FeatureFlags;
}> = ({
  children,
  formAction,
  isPending,
  submitLabel,
  onBack,
  backLabel,
  featureFlags,
}) => {
  return (
    <form noValidate action={formAction} className="flex flex-col gap-4 w-full">
      <div className="grid grid-cols-6 w-full gap-2">{children}</div>
      <div
        className={`flex col-span-6 gap-2 ${featureFlags?.reCAPTCHA ? "justify-between" : "justify-end"}`}
      >
        {featureFlags?.reCAPTCHA && (
          <div className="col-span-6 homepage-text-xs">
            Dette site er beskyttet af reCAPTCHA og Google’s{" "}
            <a
              className="underline"
              target="_blank"
              href="https://policies.google.com/privacy"
            >
              privatlivspolitik
            </a>{" "}
            og{" "}
            <a
              className="underline"
              target="_blank"
              href="https://policies.google.com/terms"
            >
              servicevilkår
            </a>{" "}
            gælder.
          </div>
        )}
        <div>
          {backLabel && onBack && (
            <Button onClick={() => onBack && onBack()}>{backLabel}</Button>
          )}
          <Button
            className=" bg-[var(--form-button-bg-color)] text-[var(--form-button-text-color)] hover:bg-[var(--form-button-hover-bg-color)] hover:text-[var(--form-button-hover-text-color)] "
            loading={isPending}
            type="submit"
          >
            {submitLabel}
          </Button>
        </div>
      </div>
    </form>
  );
};

export default FormLayout;
